module.exports = __webpack_public_path__ + "toolkit-entypo.0734b287982f2795d16b.woff";


//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/src/assets/fonts/toolkit-entypo.woff
// module id = ../../../../../src/assets/fonts/toolkit-entypo.woff
// module chunks = 3